/**
 * Emit a REAL `fetchpriority` attribute on an `<img>`.
 *
 * React 18.3.1 — the version this repo resolves — does not know the camelCase `fetchPriority` prop. It
 * warns ("React does not recognize the `fetchPriority` prop on a DOM element") and then DROPS it, so the
 * attribute never reaches the HTML and the priority hint silently does nothing. React only adopted the
 * camelCase spelling in 19. Spreading the all-lowercase name goes through React's pass-through path for
 * custom attributes instead of its prop allowlist, so the real attribute lands in the markup.
 *
 * Two sites in the product gallery had been passing the camelCase form since it was written: the LCP hint
 * on the product page has never actually been emitted. Route every use through this helper so there is one
 * place to delete when the repo moves to React 19.
 */
export function fetchPriorityAttr(priority) {
    return priority ? { fetchpriority: priority } : {};
}
//# sourceMappingURL=imgPriority.js.map